
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { fadeInVariants } from '@/lib/animations';

interface EmotionDashboardHeaderProps {
  timeRange: string;
  setTimeRange: (value: string) => void;
}

const EmotionDashboardHeader = ({ timeRange, setTimeRange }: EmotionDashboardHeaderProps) => {
  return (
    <motion.div 
      className="flex justify-between items-center mb-8"
      variants={fadeInVariants}
      initial="initial"
      animate="animate"
    >
      <div>
        <h1 className="text-2xl font-bold">dashboard de emoções</h1>
        <p className="text-gray-600">visualize e analise seu estado emocional</p>
      </div>
      
      <div className="flex gap-2">
        <Select
          value={timeRange}
          onValueChange={setTimeRange}
        >
          <SelectTrigger className="w-[160px]">
            <SelectValue placeholder="Período" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="7days">Últimos 7 dias</SelectItem>
            <SelectItem value="30days">Últimos 30 dias</SelectItem>
            <SelectItem value="90days">Últimos 90 dias</SelectItem>
            <SelectItem value="year">Este ano</SelectItem>
          </SelectContent>
        </Select>
        
        <Button variant="outline" className="flex items-center gap-1">
          <Download size={16} /> Exportar
        </Button>
        
        <Link to="/registro" state={{ defaultTab: 'emotions' }}>
          <Button className="flex items-center gap-1">
            Novo Registro
          </Button>
        </Link>
      </div>
    </motion.div>
  );
};

export default EmotionDashboardHeader;
